import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M21.99 4c0-1.1-.89-2-1.99-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14l4 4-.01-18z"
}), 'ModeComment');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/ModeComment.js
// module id = 4871
// module chunks = 2